import Vacancies from './Vacancies';
export default Vacancies;